export const PENDING_LOAN_REQUESTS_START =
  'PENDING_LOAN_REQUESTS_START';
export const PENDING_LOAN_REQUESTS_SUCCESS =
  'PENDING_LOAN_REQUESTS_SUCCESS';
export const PENDING_LOAN_REQUESTS_ERROR =
  'PENDING_LOAN_REQUESTS_ERROR';
export const PENDING_LOAN_REQUESTS_END = 'PENDING_LOAN_REQUESTS_END';
